/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Account } from '../../models/account';
import { AccountRegister } from '../../models/account-register';
import { AccountType } from '../../models/account-type';

export interface RegisterAccount$Params {

/**
 * The type of account to register.
 */
  accountType: AccountType;
      body?: AccountRegister
}

export function registerAccount(http: HttpClient, rootUrl: string, params: RegisterAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<Account>> {
  const rb = new RequestBuilder(rootUrl, registerAccount.PATH, 'post');
  if (params) {
    rb.path('accountType', params.accountType, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Account>;
    })
  );
}

registerAccount.PATH = '/account/register/{accountType}';
